import React, { Component } from 'react'
import { connect } from 'react-redux'


import { dirtyRead } from 'selectors/common'
import { tasks } from 'selectors/entities'
import { projectTasks, openTasksByProjectID } from 'selectors/tasks'

import Section from 'components/Section'
import AddButton from './AddButton'
import TaskList from './List'
import dataActions from 'actions/dataActions'
import Divider from 'material-ui/Divider'

let select = dirtyRead(
	(state, props) => {
		return ({
			tasks: projectTasks(state, props)
		  , openTasks: openTasksByProjectID(state)
		})
	}
)

export class Tasks extends Component{
	render(){
		let { props } = this
		let projectID = props.projectID
		let count = props.openTasks && props.openTasks[projectID] && props.openTasks[projectID].length? props.openTasks[projectID].length:"0"
		return(
				<Section
					id="project/tasks"
					title="Tasks"
					badge={count}
				>
					<div
						style={{
							width: "100%"
						}}
						speed={0.8}
						className="area"
						contentClassName="content"
						horizontal={false}
						verticalScrollbarStyle={{
							width: "16px"
						  , borderRadius: "13px"
						  , marginLeft: "1px"
						  , backgroundImage: "url(/landlord/static/img/bar.png)"
						  , backgroundSize: "100%"
						  , backgroundRepeat: "no-repeat"
						  , backgroundColor: "#f5f6f5"
						  , backgroundPosition: "center"
						}}
						minScrollSize={30}
						verticalContainerStyle={{
							width: "18px"
						  , backgroundColor: "#cdcdcd"
						  , opacity: "1"
						}}
						ref="right-panel"
					>
						<div>
							<div className="logical-block" style={{clear: "both", padding: '0'}}>
								<TaskList projectID={projectID} />
							</div>
						</div>
					</div>
				</Section>
		)
	}
}

export default connect(select, dataActions)(Tasks)



// WEBPACK FOOTER //
// ./src/routes/landlord/projectForm/tasks/index.js